var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaxonomyFill = function SvgTaxonomyFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "var(--primary-color)",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240zm80-400v-320h240q33 0 56.5 23.5T840-760v240zm0 400v-320h320v240q0 33-23.5 56.5T760-120z"
  })));
};
export default SvgTaxonomyFill;